import { z } from 'zod';
export const DriverLicenceSchema = z.object({
    id: z.number().optional(),
    name: z.string().optional()
});
//# sourceMappingURL=driverLicenceSchema.js.map